import React from "react";
import {useStyles} from "./styles/DialogStyle";
import {inject, observer} from "mobx-react";
import {Close} from '@material-ui/icons';
import {Box, Button, Dialog, DialogContent, IconButton, Typography} from "@material-ui/core";
import clsx from "clsx";
import {injectIntl} from "react-intl";


function ErrorDialog(props) {
    const classes = useStyles();
    const {intl} = props;

    const {
        dialogOpen,
        dialogClose,
        titleText,
        text,
    } = props;

    return (
        <Dialog
            open={dialogOpen}
            className={classes.dialogBox}
        >
            <Box
                className={classes.dialogTopBar}
            >
                <Typography className={classes.titleText}>{titleText}</Typography>
                <IconButton className={classes.iconButton} onClick={dialogClose} disableRipple>
                    <Close/>
                </IconButton>
            </Box>
            <DialogContent dividers>
                <Box className={classes.contentsBox} style={{whiteSpace: 'pre-wrap', textAlign: 'center'}}>
                    {text}
                    <Box display='flex' flexDirection={'column'} justifyContent='flex-end' alignItems='center' className={classes.controlBox}>
                        <Button className={clsx(classes.buttonStyle)} onClick={dialogClose}
                                disableRipple>
                            {intl.formatMessage({id: "confirm"})}
                        </Button>
                    </Box>
                </Box>
            </DialogContent>

        </Dialog>
    );
}

export default inject('dialogStore')(injectIntl(observer(ErrorDialog)));
